import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#DBEAFE",
      d: "M0 8a8 8 0 0 1 8-8h10a8 8 0 0 1 8 8v10a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#1E40AF",
      d: "M9.507 8.624V17h-1.68V8.624zm4.648 0q1.32 0 2.316.516a3.63 3.63 0 0 1 1.548 1.476q.552.948.552 2.208t-.552 2.208a3.67 3.67 0 0 1-1.548 1.452q-.996.516-2.316.516h-2.928V8.624zm-.06 6.948q1.32 0 2.04-.72t.72-2.028-.72-2.04q-.72-.744-2.04-.744h-1.188v5.532z"
    }, null, -1)
  ]))]))
}
export default { render: render }